import { render, staticRenderFns } from "./ModalInfo.vue?vue&type=template&id=4bde9d76&scoped=true"
import script from "./ModalInfo.vue?vue&type=script&lang=js"
export * from "./ModalInfo.vue?vue&type=script&lang=js"
import style0 from "./ModalInfo.vue?vue&type=style&index=0&id=4bde9d76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bde9d76",
  null
  
)

export default component.exports